import { render } from "./ForumPostEditor.vue?vue&type=template&id=b16b7706"
import script from "./ForumPostEditor.vue?vue&type=script&lang=js"
export * from "./ForumPostEditor.vue?vue&type=script&lang=js"

import "./ForumPostEditor.vue?vue&type=style&index=0&id=b16b7706&lang=css"

import exportComponent from "/home/runner/work/web-frontend-dev/web-frontend-dev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__